const updates = [
  {
    date: '2026.07.31',
    title: '平台服务器全面升级完成',
    desc: '悟空影视已完成全球服务器节点扩容升级，新增亚洲、北美、欧洲三大区域 15 个 CDN 加速节点。即日起播放速度提升 40%，高峰期卡顿问题大幅改善。',
    icon: 'ri-server-line',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    date: '2026.07.28',
    title: '新增 4K 超清专区',
    desc: '悟空影视正式上线 4K 超清内容专区，首批上线 500+ 部支持 4K 画质的影视作品，覆盖热门电影、纪录片和精选剧集。在网络条件允许的情况下，可享受极致清晰观影体验。',
    icon: 'ri-4k-line',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    date: '2026.07.25',
    title: '智能推荐算法上线',
    desc: '全新智能推荐系统正式运行，基于您的观影历史和偏好，精准推送你可能喜欢的内容。首页「猜你喜欢」板块已同步更新，快去发现你的下一部心头好吧。',
    icon: 'ri-robot-line',
    color: 'bg-secondary-100 text-secondary-600',
  },
  {
    date: '2026.07.20',
    title: '暑期档专题页面上线',
    desc: '暑期档特别策划「夏日追剧计划」正式推出，精选 100 部高分电影和热播剧集，涵盖动作、喜剧、动画等多种类型。每周更新精选片单，陪你度过清凉一夏。',
    icon: 'ri-sun-line',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    date: '2026.07.15',
    title: '夜间模式功能发布',
    desc: '响应广大用户呼声，悟空影视正式推出夜间模式功能。在设置中一键切换，深色界面配合降低亮度，夜间追剧不刺眼。同时支持跟随系统自动切换明暗主题。',
    icon: 'ri-moon-line',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    date: '2026.07.10',
    title: '播放器全面改版',
    desc: '全新播放器界面简洁大气，新增倍速播放（0.5x-3x）、画中画模式、快捷键支持（空格暂停、方向键快进快退）等功能。兼容性大幅提升，覆盖更多浏览器和设备。',
    icon: 'ri-play-circle-line',
    color: 'bg-secondary-100 text-secondary-600',
  },
  {
    date: '2026.07.05',
    title: '会员专属片库开放免费观看',
    desc: '原 VIP 专属片库中的 300+ 部精选内容现已面向全体用户开放免费观看，包括多部奥斯卡获奖影片和戛纳电影节入围作品。优质内容普惠计划持续推进中。',
    icon: 'ri-vip-diamond-line',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    date: '2026.07.01',
    title: '悟空影视月活用户突破 5000 万',
    desc: '感谢每一位用户的支持与信任！悟空影视月度活跃用户正式突破 5000 万大关。我们将继续坚持免费、高清、流畅的服务理念，为更多影迷提供优质的在线观影体验。',
    icon: 'ri-fire-line',
    color: 'bg-primary-100 text-primary-600',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-1">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500">平台更新与重要公告，第一时间知晓</p>
        </div>

        <div className="relative">
          <div className="absolute left-5 top-0 bottom-0 w-px bg-background-300/60 hidden md:block"></div>
          <div className="space-y-6">
            {updates.map((item, idx) => (
              <div key={idx} className="relative flex gap-4 md:gap-6">
                <div className="hidden md:flex flex-shrink-0 relative z-10">
                  <span className={`w-10 h-10 flex items-center justify-center rounded-full ${item.color}`}>
                    <i className={`${item.icon} text-base`}></i>
                  </span>
                </div>
                <div className="flex-1 bg-background-50 rounded-xl border border-background-200/60 p-4 md:p-5">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className="px-2 py-0.5 rounded bg-background-200/70 text-xs font-medium text-foreground-500 whitespace-nowrap">
                      {item.date}
                    </span>
                    <span className={`md:hidden w-7 h-7 flex items-center justify-center rounded-full ${item.color}`}>
                      <i className={`${item.icon} text-xs`}></i>
                    </span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1.5">{item.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}